import React from "react";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

import AvatarPlaceholder from "src/images/avatar-purple.svg";
import LazyImage from "src/app/components/LazyImage/LazyImage";

export const createUserOptions = (membersList, members) => {
  return membersList
    .filter(
      (identityMember) =>
        !members.find((user) => user.id === identityMember.id) &&
        identityMember &&
        identityMember?.status !== "removed" &&
        !identityMember?.hideOnMembersList,
    )
    .map((user) => ({
      label: (
        <div className="members__user-select-option">
          <LazyImage
            className="members__user-select-option__photo"
            src={user.avatarUrl || AvatarPlaceholder}
            alt="avatar"
            placeholder={AvatarPlaceholder}
          />
          <div className="members__user-select-option__details">
            <div className="members__user-select-option__details-name">
              {user.name}
            </div>
            {user.isClient && (
              <div className="members__user-select-option__details-client">
                <IDHFormattedMessage id="ws_client" defaultMessage="Client" />
              </div>
            )}
            <div className="members__user-select-option__details-email">
              {user.email}
            </div>
          </div>
        </div>
      ),
      value: { email: user.email, name: user.name, id: user.id },
      color: user.isClient ? "#F7911A" : "#6A6D7C",
      backgroundColor: user.isClient ? "#FFF5E9" : "#EDEDEF",
    }));
};
